import React from 'react';

const ReloadPageButton = () => {
    return (
        <button className="btn btn-primary mx-2" onClick={() => { window.location.reload() } }>Reload Page</button>
    );
}

export default ReloadPageButton;